import { render, staticRenderFns } from "./allApplications.vue?vue&type=template&id=5fd50903&scoped=true&"
import script from "./allApplications.vue?vue&type=script&lang=js&"
export * from "./allApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd50903",
  null
  
)

export default component.exports